import { render, staticRenderFns } from "./SettingExamToLecture.vue?vue&type=template&id=023e460d"
import script from "./SettingExamToLecture.vue?vue&type=script&lang=js"
export * from "./SettingExamToLecture.vue?vue&type=script&lang=js"
import style0 from "./SettingExamToLecture.vue?vue&type=style&index=0&id=023e460d&prod&lang=css&scope=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports